import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h4><a parentName="h4" {...{
        "href": "/ui-patterns/button-usage"
      }}>{`Button usage`}</a></h4>
    <p>{`Buttons are a fundamental building block of the GitHub UI. These guidelines summarize how to use buttons across the product.`}</p>
    <h4><a parentName="h4" {...{
        "href": "/ui-patterns/dates-and-times"
      }}>{`Dates and times`}</a></h4>
    <p>{`Dates and times are used to provide context and information about when something happened or will happen. These guidelines summarize how to use dates and times across the product.`}</p>
    <h4><a parentName="h4" {...{
        "href": "/ui-patterns/empty-states"
      }}>{`Empty states`}</a></h4>
    <p>{`Empty states are used to fill spaces when no content has been added yet, or is temporarily empty due to the nature of the feature. These guidelines demonstrate best practices for using the blankslate component and designing empty states.`}</p>
    <h4><a parentName="h4" {...{
        "href": "/ui-patterns/feature-onboarding"
      }}>{`Feature onboarding`}</a></h4>
    <p>{`Onboarding is a virtual unboxing experience that helps users get started with a feature. This is a guide for designing onboarding for the product and does not include what to do for marketing pages, email announcements, social media, etc.`}</p>
    <h4><a parentName="h4" {...{
        "href": "/ui-patterns/forms"
      }}>{`Forms`}</a></h4>
    <p>{`Forms are used to complete tasks that require data input from the user. These guidelines aim to minimize the effort and cognitive load required to complete a task that involves a form.`}</p>
    <h4><a parentName="h4" {...{
        "href": "/ui-patterns/messaging"
      }}>{`Messaging`}</a></h4>
    <p>{`Messaging components are used to provide important and relevant information to the user, including feedback, contextual information, product updates, and more. Primer includes three different messaging components: toasts, flash alerts, popovers.`}</p>
    <h4><a parentName="h4" {...{
        "href": "/ui-patterns/progressive-disclosure"
      }}>{`Progressive disclosure`}</a></h4>
    <p>{`These guidelines summarize how to use progressive disclosure, as well as guiding principles, best practices, and implementation support.`}</p>
    <h4><a parentName="h4" {...{
        "href": "/ui-patterns/saving"
      }}>{`Saving`}</a></h4>
    <p>{`Saving and submitting data is critical to task completion. Use these guidelines to ensure your workflows are
consistent and accessible.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      